import React, { Component } from 'react';
import 'babel-polyfill';
import { Form, Icon, Input, Button, Select } from "antd";
import { reactLocalStorage } from "reactjs-localstorage";
import "../styles/css/login.scss";
import { getRegisterCode, register } from "./api/categories";
import	RealTimeAI from "./realTimeAI";
class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: '',
      hospital: '',
      password: '',
      phone: '',
      smsCode: '',
      timeLeft: 60,
      isCountingDown: false,
      email: '',
      title: '',
      sex: '',
    };
  }

  validatePhoneNumber = (phone) => {
    // Regular expression: starts with 1, followed by 10 digits
    const phoneRegex = /^1[3-9]\d{9}$/;
    return phoneRegex.test(phone);
  }

  startTimer = (callback) => {
    this.setState({ isCountingDown: true, timeLeft: 60 });
    this.countdown = setInterval(() => {
      this.setState((prevState) => ({
        timeLeft: prevState.timeLeft > 0 ? prevState.timeLeft - 1 : 0,
        isCountingDown: prevState.timeLeft > 1 ? true : false,
      }));
    }, 1000);

    // Reset the timer after 60 seconds
    setTimeout(() => {
      clearInterval(this.countdown);
      if (callback) {
        callback();
      }
    }, 60000);
  }

  getLoginCode = async () => {
    const { phone } = this.state;
    if (this.validatePhoneNumber(phone)) {
      if (!this.state.isCountingDown) {
        this.startTimer(() => {
          this.setState({ isCountingDown: false });
          alert("You can get the verification code again.");
        });
        try {
          const res = await getRegisterCode({ phone });
          console.log(res);
          if (res.code !== "200") {
            alert(res.msg);
          }
        } catch (error) {
          console.error("Request failed:", error);
          alert("Request failed, please try again later");
        }
      }
    } else {
      alert("Incorrect phone number");
    }
  };

  setCookie = (name, value, iDay) => {
    const oDate = new Date();
    oDate.setDate(oDate.getDate() + iDay);
    document.cookie = `${name}=${value};expires=${oDate}`;
  }

  handleSmsLogin = async (e) => {
    e.preventDefault();
    console.log('Registration information:', this.state);
    const { userName, password, phone, smsCode, hospital, email, title, sex } = this.state;

    try {
      const res = await register({ userName, password, phone, code: smsCode, hospital, email, title, sex });
      console.log(res);
      if (res.code === "200") {
        sessionStorage.setItem("username", res.data.userName);
        sessionStorage.setItem("userName", res.data.phone);
        sessionStorage.setItem("userId", res.data.id);
        sessionStorage.setItem("bigvideo", 1);
        sessionStorage.setItem("times", res.data.times);
        sessionStorage.setItem("activate", res.data.activate);
        sessionStorage.setItem("token", new Date().getTime());
        this.setCookie("logostatelocal", 1, 1);
        this.setCookie("yk", 0);
        this.props.history.push("/UserLogin");
      } else {
        alert(res.msg);
      }
    } catch (error) {
      console.error("Request failed:", error);
      alert("Request failed, please try again later");
    }
  };

  inputChange = (field, value) => {
    this.setState({ [field]: value });
  };

  componentWillUnmount() {
    if (this.countdown) {
      clearInterval(this.countdown);
    }
  }

  render() {
    const { timeLeft, isCountingDown, userName, hospital, password, phone, smsCode } = this.state;
    const buttonText = isCountingDown ? `${timeLeft} seconds` : 'Dispatch';

    return (
      <div className="login-main" style={{ height: "100vh", overflow: "auto" }}>
        <div className="login-bg" style={{ height: "100vh", overflow: "auto" }}>
          <div style={{ fontSize: "33px", width: "500px", marginLeft: "5%", textAlign: "center", marginTop: "-100px" }}>
            <Form onSubmit={this.handleSmsLogin} className="login-form" style={{ padding: "5px", marginLeft: "10px" }}>
              <h1 className="login-title">Register</h1>
              <Form.Item name="userName" rules={[{ required: true, message: "Please enter a nickname" }]}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                  <div style={{  width: "150px" }}>Nickname:</div>
                  <Input
                    onChange={(e) => this.inputChange('userName', e.target.value)}
                    prefix={<Icon type="user" className="login-input-icon" />}
                    placeholder="Nickname"
                  />
                </div>
              </Form.Item>
              <Form.Item name="hospital" rules={[{ required: true, message: "Please enter hospital name" }]}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
                  <div style={{  width: "150px" }}>MedicalInstitution:</div>
                  <Input
                    onChange={(e) => this.inputChange('hospital', e.target.value)}
                    prefix={<Icon type="home" className="login-input-icon" />}
                    placeholder="MedicalInstitution"
                  />
                </div>
              </Form.Item>
              <Form.Item name="password" rules={[{ required: true, message: "Please enter password" }]}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
                  <div style={{  width: "150px" }}>Password:</div>
                  <Input
                    type="password"
                    onChange={(e) => this.inputChange('password', e.target.value)}
                    prefix={<Icon type="lock" className="login-input-icon" />}
                    placeholder="Password"
                  />
                </div>
              </Form.Item>
			  <Form.Item name="confirmPassword" rules={[{ required: true, message: "Please enter confirmPassword" }]}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
                  <div style={{  width: "150px" }}>ConfirmPassword:</div>
                  <Input
                    type="confirmPassword"
                    onChange={(e) => this.inputChange('confirmPassword', e.target.value)}
                    prefix={<Icon type="lock" className="login-input-icon" />}
                    placeholder="ConfirmPassword"
                  />
                </div>
              </Form.Item>
              <Form.Item name="email" rules={[{ required: true, message: "Please enter email" }]}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
                  <div style={{  width: "150px" }}>E-mail:</div>
                  <Input
                    onChange={(e) => this.inputChange('email', e.target.value)}
                    prefix={<Icon type="mail" className="login-input-icon" />}
                    placeholder="E-mail"
                  />
                </div>
              </Form.Item>
              <Form.Item name="sex" rules={[{ required: true, message: "Please select gender" }]}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
                  <div style={{  width: "150px" }}>Gender:</div>
                  <Select onChange={(value) => this.inputChange('sex', value)}>
                    <Select.Option value="male">Male</Select.Option>
                    <Select.Option value="female">Female</Select.Option>
                  </Select>
                </div>
              </Form.Item>
              <Form.Item name="title" rules={[{ required: true, message: "Please select title" }]}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
                  <div style={{  width: "150px" }}>Title:</div>
                  <Select onChange={(value) => this.inputChange('title', value)}>
                    <Select.Option value="doctor">Doctor</Select.Option>
                    <Select.Option value="technician">Technician</Select.Option>
                    <Select.Option value="teacher">Teacher</Select.Option>
                    <Select.Option value="student">Student</Select.Option>
                    <Select.Option value="other">Other</Select.Option>
                  </Select>
                </div>
              </Form.Item>
              <Form.Item name="phoneNumber" rules={[{ required: true, message: "Please enter phone number" }]}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
                  <div style={{  width: "150px" }}>Mobile:</div>
                  <Input
                    onChange={(e) => this.inputChange('phone', e.target.value)}
                    prefix={<Icon type="phone" className="login-input-icon" />}
                    placeholder="Mobile"
                  />
                </div>
              </Form.Item>
              <Form.Item name="smsCode" rules={[{ required: true, message: "Please enter verification code" }]}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
                  <div style={{  width: "150px" }}>Verify:</div>
                  <div style={{ width: "100%", marginLeft: "-40px" }}>
                    <Input
                      style={{ width: "80%" }}
                      onChange={(e) => this.inputChange('smsCode', e.target.value)}
                      prefix={<Icon type="key" className="login-input-icon" />}
                      placeholder="Verify"
                    />
                  </div>
                  <Button
                    style={{ width: "20%" }}
                    type="primary"
                    className="login-join-button"
                    onClick={this.getLoginCode}
                    disabled={isCountingDown}
                  >
                    {buttonText}
                  </Button>
                </div>
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-join-button"
                >
                  Register
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

export default Register;